import axios from 'axios';

class OrganizationSingleton {
  private static getter: () => string = () => '';
  static setGetter(getter: () => string) {
    OrganizationSingleton.getter = getter;
  }
  static get() {
    return OrganizationSingleton.getter();
  }
}

axios.interceptors.request.use((config) => {
  const org = OrganizationSingleton.get();
  // 組織パラメータがすでに存在する場合は追加しない。設定画面では、サービスの選択に基づいてパラメータを送信します。

  const hasOrgInUrl = (() => {
    if (!config.url) {
      return false;
    }

    try {
      const url = new URL(config.url, window.location.origin);
      return url.searchParams.has('organization');
    } catch (error) {
      return false;
    }
  })();

  if (org && !hasOrgInUrl) {
    config.params = { ...(config.params || {}), organization: org };
  }

  return config;
});

export const setOrganizationGetter = OrganizationSingleton.setGetter;
